import React from 'react';
import { useFormikContext } from 'formik';
import { Typography } from '@mui/material';
import { YesNoSelector } from '@fnol/library/src/components';
import { legalPersonType, personType, translations } from '../../lib/consts';
import Individual from '../Individual';
import LegalIndividualSelector from '../LegalIndividualSelector';
import LegalLeasingEntity from '../LegalLeasingEntity';
import { IndividualCleanup } from '../Individual/Individual';
import { LegalLeasingCleanup } from '../LegalLeasingEntity/LegalLeasingEntity';

const VehicleUser = () => {
    const { values, setFieldValue } = useFormikContext<any>();

    const legalEntityUpperCase = values.submitterLegalNameForDisplay.toUpperCase();

    const relationLegalRepresentative =
        values.ownerIndividualSubmitterRelationId === 3 || values.ownerLegalEntityPersonRoleId === 3;
    const relationOther =
        values.ownerIndividualSubmitterRelationId === 12 || values.ownerLegalEntityPersonRoleId === 12;

    const handleChangeHowIsVehicleUsed = () => {
        setFieldValue('submitterUserByVehicleRegistration', '');
        setFieldValue('userType', '');
    };

    const handleChangesubmitterUserByVehicleRegistration = () => {
        IndividualCleanup(personType.user, setFieldValue);
        LegalLeasingCleanup(personType.user, setFieldValue);
        setFieldValue('userType', '');
    };

    return (
        <>
            {values.isSubmitterOwnerOfVehicle === 'false' && (relationLegalRepresentative || relationOther) && (
                <>
                    <Typography
                        style={{ fontWeight: 'bold', fontSize: '18px', paddingTop: '16px' }}
                        variant="subtitle1"
                    >
                        {translations.vehicleUser.VEHICLE_USER}
                    </Typography>
                    <Typography variant="subtitle1">{translations.vehicleUser.VEHICLE_USED_BY}</Typography>
                    <YesNoSelector name="howIsVehicleUsed" onChange={handleChangeHowIsVehicleUsed} />
                </>
            )}
            {values.howIsVehicleUsed === 'true' &&
                values.submitterType === legalPersonType.individual &&
                (relationLegalRepresentative || relationOther) && (
                    <>
                        <Typography variant="subtitle1">{translations.vehicleUser.ARE_YOU_USER}</Typography>
                        <YesNoSelector
                            name="submitterUserByVehicleRegistration"
                            onChange={handleChangesubmitterUserByVehicleRegistration}
                        />
                    </>
                )}
            {values.howIsVehicleUsed === 'true' &&
                values.submitterType === legalPersonType.legal &&
                (relationLegalRepresentative || relationOther) && (
                    <>
                        <Typography variant="subtitle1">
                            {`${translations.vehicleUser.LEGAL} ${legalEntityUpperCase} ${translations.vehicleUser.LEGAL2}`}
                        </Typography>
                        <YesNoSelector
                            name="submitterUserByVehicleRegistration"
                            onChange={handleChangesubmitterUserByVehicleRegistration}
                        />
                    </>
                )}
            {values.howIsVehicleUsed === 'true' &&
                (relationLegalRepresentative || relationOther) &&
                values.submitterUserByVehicleRegistration === 'false' && (
                    <>
                        <Typography variant="subtitle1">{translations.vehicleUser.USER_IS}</Typography>
                        <LegalIndividualSelector selectorType={personType.user} />
                        {values.userType === legalPersonType.individual && (
                            <Individual individualType={personType.user} />
                        )}
                        {values.userType === legalPersonType.legal && (
                            <LegalLeasingEntity legalEntityType={personType.user} />
                        )}
                    </>
                )}
        </>
    );
};

export default VehicleUser;
